import React, { useEffect, useState } from 'react'
import TestimonialService from '../../../services/KangarooServices/TestimonialService';
import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row, Spinner } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { imageBaseApi } from '../../../utilis/imageHelper';
import { Edit3 } from 'lucide-react';

const TestimonialDetail = () => {
    const [loading, setLoading] = useState(false);
    const[data, setData] = useState(null);
    const {id} = useParams();
  const navigate = useNavigate()
    const fetchDetail = async () => {
        if (!id) return;
        setLoading(true);
        try {
          const result = await TestimonialService.getDetail(id);
          setData(result);
        } catch (error) {
          console.error(error);
        } finally {
          setLoading(false);
        }
      };
    
      useEffect(() => {
        fetchDetail(id);
      }, [id]);


      const renderStars = (rating) => {
        return [...Array(5)].map((_, i) => (
          <i
            key={i}
            className={`bi ${
              i < rating ? "bi-star-fill text-warning" : "bi-star text-muted"
            }`}
            style={{ fontSize: "0.8rem", marginRight: "2px" }}
          ></i>
        ));
      };

     const convertToEmbedUrl = (url) => {
  if (!url || typeof url !== "string") return "";

  // YouTube
  if (url.includes("youtube.com") || url.includes("youtu.be")) {
    let videoId = "";
    if (url.includes("v=")) {
      videoId = url.split("v=")[1]?.split("&")[0]; // safe split
    } else if (url.includes("youtu.be/")) {
      videoId = url.split("youtu.be/")[1]?.split("?")[0]; // safe split
    }
    return videoId ? `https://www.youtube.com/embed/${videoId}` : "";
  }

  // Vimeo
  if (url.includes("vimeo.com")) {
    const videoId = url.split("/").pop();
    return videoId ? `https://player.vimeo.com/video/${videoId}` : "";
  }

  return url; // fallback: return original URL
};
  return (
    <div className='page-content'>
  <Container fluid>
    <BreadCrumb 
      title="Details" 
      pageTitle="Testimonial" 
      breadcrumbItems={[{ title: "Back to List", link: "/testimonial" }]}
    />

    {loading ? (
      <div className="text-center py-5">
        <Spinner color="primary" />
      </div>
    ) : (
      <Row className="gy-4">
        <Col lg={12}>
          <Card className="shadow-sm border-0 overflow-hidden">
            <div className="bg-primary bg-gradient" style={{ height: '6px' }}></div>
            <CardBody className="p-4">
              
              {/* Header */}
              <div className="d-flex align-items-center mb-4">
                <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                  <i className="bx bxs-user-voice text-primary" style={{ fontSize: '24px' }}></i>
                </div>
                 <div className="position-absolute  me-3" style={{ right: "0",zIndex: 100 }}>

                <button
                        type="button"
                        className="btn btn-sm btn-primary d-flex align-items-center gap-1"
                        onClick={() => navigate(`/testimonialform/update/${id}`)}
                        style={{ fontSize: "0.875rem" }}
                      >
                        <Edit3 size={14} />
                        Update 
                      </button>
                </div>
                <h5 className="mb-0 fw-semibold">Testimonial Information</h5>
              </div>

              <Row className="align-items-center">
                {/* Left: Image */}
                <Col md={4} className="text-center mb-3 mb-md-0">
                  <div
                    className="rounded-circle overflow-hidden border border-light"
                    style={{
                      width: "180px",
                      height: "180px",
                      margin: "0 auto",
                      boxShadow: "0 6px 15px rgba(0,0,0,0.1)",
                    }}
                  >
                    <img
                      src={`${imageBaseApi}${data?.studentPhoto?.url}`}
                      alt={data?.studentName}
                      className="img-fluid"
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  </div>
                </Col>

                {/* Right: Details */}
                <Col md={8}>
                  <Row>
                    <Col md={6}>
                      <div className="mb-4">
                        <label className="text-muted small mb-1 d-flex align-items-center">
                          <i className="bx bx-user me-1"></i> Student Name
                        </label>
                        <p className="fw-semibold mb-0">{data?.studentName}</p>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="mb-4">
                        <label className="text-muted small mb-1 d-flex align-items-center">
                          <i className="bx bx-book-open me-1"></i> Course Name
                        </label>
                        <p className="fw-semibold mb-0">{data?.courseName}</p>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="mb-4">
                        <label className="text-muted small mb-1 d-flex align-items-center">
                          <i className="bx bx-world me-1"></i> Destination Country
                        </label>
                        <p className="fw-semibold mb-0">
                          <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2">
                            {data?.destinationCountryName}
                          </span>
                        </p>
                      </div>
                    </Col>

                    <Col md={6}>
                      <div className="mb-4">
                        <label className="text-muted small mb-1 d-flex align-items-center">
                          <i className="bx bx-building me-1"></i> University Name
                        </label>
                        <p className="fw-semibold mb-0">{data?.universityName}</p>
                      </div>
                    </Col>

                    <Col md={12}>
                      <div className="mb-3">
                        <label className="text-muted small mb-1 d-flex align-items-center">
                          <i className="bx bx-star me-1"></i> Rating
                        </label>
                        <p className="fw-semibold mb-0">{renderStars(data?.rating)}</p>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>

              {/* Testimonial Text */}
              <div className="mb-4">
                <label className="text-muted small mb-1 d-flex align-items-center">
                  <i className="bx bx-message-square-detail me-1"></i> Testimonial
                </label>
                <div className="bg-light rounded p-3">
                  <p className="fw-semibold mb-0">{data?.text}</p>
                </div>
              </div>

              {/* Video */}
              {data?.videoUrl && (
                <div className="mt-4">
                  <label className="text-muted small mb-2 d-flex align-items-center">
                    <i className="bx bx-video me-1"></i> Video Testimonial
                  </label>
                  <div className="ratio ratio-16x9 rounded" style={{ overflow: 'hidden' }}>
                    <iframe
                      src={convertToEmbedUrl(data?.videoUrl)}
                      title="Student Video"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={{ border: 'none' }}
                    ></iframe>
                  </div>
                </div>
              )}

            </CardBody>
          </Card>
        </Col>
      </Row>
    )}
      
  </Container>
</div>
  )
}

export default TestimonialDetail
